import modalBgLg from "../Assets/popup/Offer-for website.jpg";
import modalBgsm from "../Assets/popup/Offer.jpg";
import { useEffect, useState } from "react";
import { XIcon } from "lucide-react";
import { Link } from "react-router-dom";
const DiscountModal = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleBookNowClick = () => {
    sessionStorage.setItem("discountCode", "LOVE20");
    setIsModalOpen(false);
  };

  // auto open after 20s (once per session)
  useEffect(() => {
    const hasSeenModal = sessionStorage.getItem("autoModalSeen");

    if (!hasSeenModal) {
      const timer = setTimeout(() => {
        setIsModalOpen(true);
        sessionStorage.setItem("autoModalSeen", "true");
      }, 20000);

      return () => clearTimeout(timer);
    }
  }, []);

  // disable scroll when modal open
  useEffect(() => {
    document.body.style.overflow = isModalOpen ? "hidden" : "auto";

    return () => {
      document.body.style.overflow = "auto";
    };
  }, [isModalOpen]);

  return (
    <>
      {isModalOpen && (
        <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/50 px-5">
          <div className="lg:max-w-xl max-w-[350px] lg:h-[420px] h-4/6 rounded-xl overflow-hidden w-full relative bg-center bg-contain bg-no-repeat">
            <button
              onClick={() => setIsModalOpen(false)}
              className="absolute top-5 right-5 text-black cursor-pointer"
            >
              <XIcon className="text-red-500" />
            </button>

            <div className="w-full h-full flex">
              <img
                src={modalBgLg}
                alt=""
                className="w-full h-full object-contain lg:block hidden"
              />
              <img
                src={modalBgsm}
                alt=""
                className="w-full h-full object-cover lg:hidden block"
              />
              <Link to="/properties?discountCode=LOVE20" onClick={handleBookNowClick}>
                <button className="absolute bottom-[28px] lg:right-[50px] right-[105px] bg-[#cc001d] text-white px-8 py-[4px] rounded-md">
                  Book Now
                </button>
              </Link>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default DiscountModal;
